import { CalendarDateFormatter, DateFormatterParams } from 'angular-calendar';
import moment from 'moment';
import 'moment/locale/fr';

export class CustomDateFormatter extends CalendarDateFormatter {
  public dayViewHour({ date, locale }: DateFormatterParams): string {
    return moment(date).locale(locale).format('HH [h]');
  }

  public weekViewHour({ date, locale }: DateFormatterParams): string {
    return this.dayViewHour({ date, locale });
  }

  public dayViewTitle({ date, locale }: DateFormatterParams): string {
    return moment(date).locale(locale).format('dddd Do MMMM YYYY');
  }

  public weekViewTitle({ date, locale, weekStartsOn, excludeDays, daysInWeek }: DateFormatterParams): string {
    const sameYear: boolean = moment(date).startOf('week').isSame(moment(date).endOf('week'), 'year');
    const sameMonth: boolean = sameYear && moment(date).startOf('week').isSame(moment(date).endOf('week'), 'month');
    return (
      moment(date)
        .startOf('week')
        .locale(locale)
        .format('D' + (!sameMonth ? ' MMM' : '') + (!sameYear ? ' YYYY' : '')) +
      ' - ' +
      moment(date).endOf('week').locale(locale).format('D MMM YYYY')
    );
  }

  public weekViewColumnSubHeader({ date, locale }: DateFormatterParams): string {
    return moment(date).locale(locale).format('D MMM');
  }
}
